document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.da-tabbed-product-slider');
  if (!section) return;

  // --- 1. Recently Viewed Recording ---
  recordRecentlyViewed();

  // --- 2. Tab Switching Logic ---
  const tabBtns = section.querySelectorAll('.da-tps-tab-btn');
  const contents = section.querySelectorAll('.da-tps-content');
  const swipers = {}; // Store swiper instances

  // Initialize the first active tab
  const initialActiveTab = section.querySelector('.da-tps-tab-btn.active');
  if (initialActiveTab) {
    updateTabLine(initialActiveTab);
    activateTab(initialActiveTab.dataset.tab);
  }

  // Update line on resize
  window.addEventListener('resize', () => {
    const currentActive = section.querySelector('.da-tps-tab-btn.active');
    if (currentActive) updateTabLine(currentActive);
  });

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;

      // Update Buttons
      tabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      updateTabLine(btn);

      // Update Content
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none'; // Ensure display:none for clean transition
      });

      const targetContent = section.querySelector(`#da-tab-${tabId}-content`);
      if (targetContent) {
        targetContent.style.display = 'block';
        // Small timeout to allow display:block to apply before adding opacity class
        setTimeout(() => {
          targetContent.classList.add('active');
          activateTab(tabId);
        }, 10);
      }
    });
  });

  function updateTabLine(activeTab) {
    const line = activeTab.parentElement.querySelector('.da-tps-line');
    if (line) {
      line.style.width = `${activeTab.offsetWidth}px`;
      line.style.left = `${activeTab.offsetLeft}px`;
    }
  }

  function activateTab(tabId) {
    const wrapper = section.querySelector(`#da-tab-${tabId}-wrapper`);
    const sourceType = wrapper.dataset.sourceType;
    const swiperContainer = section.querySelector(`.da-tps-swiper[data-swiper-id="${tabId}"]`);

    // If already initialized, update
    if (swipers[tabId]) {
      swipers[tabId].update();
      return;
    }

    // Load content if needed
    if (sourceType === 'recently_viewed') {
      if (wrapper.dataset.loaded === 'true') {
        initSwiper(tabId, swiperContainer);
      } else {
        loadRecentlyViewed(wrapper).then(() => {
          wrapper.dataset.loaded = 'true';
          initSwiper(tabId, swiperContainer);
        });
      }
    } else {
      // Static content (Collection/Product List)
      initSwiper(tabId, swiperContainer);
    }
  }

  function initSwiper(tabId, container) {
    if (swipers[tabId]) return;

    const desktopItems = parseFloat(container.dataset.desktop) || 4;
    const tabletItems = parseFloat(container.dataset.tablet) || 3;
    const mobileItems = parseFloat(container.dataset.mobile) || 1.5;

    swipers[tabId] = new Swiper(container, {
      slidesPerView: mobileItems,
      spaceBetween: 15,
      navigation: {
        nextEl: container.querySelector('.da-swiper-button-next'),
        prevEl: container.querySelector('.da-swiper-button-prev'),
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: tabletItems,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: desktopItems,
          spaceBetween: 30,
        },
      },
    });
  }

  // --- 3. Recently Viewed Fetching ---
  async function loadRecentlyViewed(wrapper) {
    // Clear loading text
    wrapper.innerHTML = '';

    let handles = getRecentlyViewedHandles();

    // Filter out current product if on a product page
    if (window.location.pathname.includes('/products/')) {
      const pathParts = window.location.pathname.split('/');
      const currentHandle = pathParts[pathParts.indexOf('products') + 1];
      if (currentHandle) {
        handles = handles.filter(h => h !== currentHandle);
      }
    }

    if (handles.length === 0) {
      wrapper.innerHTML = '<div class="da-tps-loading">No recently viewed products.</div>';
      return;
    }

    const promises = handles.map(handle => fetchProductCard(handle));
    const cards = await Promise.all(promises);

    const validCards = cards.filter(html => html !== null);

    if (validCards.length === 0) {
      wrapper.innerHTML = '<div class="da-tps-loading">No recently viewed products found.</div>';
      return;
    }

    validCards.forEach(html => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide da-tps-slide';
      slide.innerHTML = html;
      wrapper.appendChild(slide);
    });
  }

  async function fetchProductCard(handle) {
    try {
      const response = await fetch(`/products/${handle}?section_id=da-recently-viewed-card`);
      if (!response.ok) throw new Error('Network response was not ok');
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const cardContainer = doc.querySelector('.da-product-card-container');
      // If the card renderer wraps in a container, extract the inner HTML or the container itself
      // Assuming product-grid renders a custom element or div
      return cardContainer ? cardContainer.innerHTML : null;
    } catch (error) {
      console.warn(`Failed to fetch product card for ${handle}:`, error);
      return null;
    }
  }

  function recordRecentlyViewed() {
    // Only on product pages
    if (!window.location.pathname.includes('/products/')) return;

    // Extract handle from URL
    const pathParts = window.location.pathname.split('/');
    const handleIndex = pathParts.indexOf('products') + 1;
    if (handleIndex === 0 || handleIndex >= pathParts.length) return;

    const handle = pathParts[handleIndex];
    if (!handle) return;

    let handles = getRecentlyViewedHandles();

    // Remove if exists (to move to top)
    handles = handles.filter(h => h !== handle);

    // Add to beginning
    handles.unshift(handle);

    // Limit to 10
    if (handles.length > 10) {
      handles = handles.slice(0, 10);
    }

    localStorage.setItem('da-recently-viewed', JSON.stringify(handles));
  }

  function getRecentlyViewedHandles() {
    try {
      const stored = localStorage.getItem('da-recently-viewed');
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Error reading recently viewed', e);
      return [];
    }
  }

});